<template>
  <v-container fluid pa-0>
    <a-search :title="$t('backups')" icon="backup" />
    <v-layout row wrap justify-center style="margin-top: -65px">
      <v-card class="flex xs11">
        <v-toolbar color="grey6 elevation-0">
          <v-btn
            color="primary"
            v-if="can.add"
            @click="createBackup"
            :loading="btn_loading"
            >{{ $t("new_record") }}</v-btn
          >
          <v-spacer />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="getData"
            :loading="loading"
            color="grey darken-2"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
        </v-toolbar>

        <v-data-table
          :items="items"
          :loading="loading"
          :headers="headers"
          class="elevation-1"
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="{ item }">
            <td>{{ item.name }}</td>
            <td>{{ item.last_modified }}</td>
            <td>{{ item.size }}</td>
            <td>
              <v-btn flat icon color="grey darken-1">
                <v-icon @click="downloadBackup(item)">file_download</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import debounce from "@/plugins/vDebounce";

export default {
  data() {
    return {
      items: [],
      loading: false,
      btn_loading: false,
    };
  },
  computed: {
    can() {
      return {
        add: this.userCan("add_backups"),
        view: this.userCan("view_backups"),
        edit: this.userCan("edit_backups"),
        delete: this.userCan("delete_backups"),
        any:
          this.userCan("edit_backups") ||
          this.userCan("view_backups") ||
          this.userCan("delete_backups"),
      };
    },
    headers: (vm) => {
      let items = [
        {
          value: "name",
          text: vm.$t("file"),
        },
        {
          text: vm.$t("date"),
          value: "last_modified",
        },
        {
          value: "size",
          text: vm.$t("size"),
        },
      ];
      if (vm.can.any)
        items.push({
          sortable: false,
          value: "actions",
          text: vm.$t("actions"),
        });
      return items;
    },
  },
  methods: {
    getData() {
      this.loading = true;
      this.axios
        .get(`backups`)
        .then((resp) => {
          this.items = resp.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    downloadBackup(item) {
      this.axios({
        method: "GET",
        url: `backups/${item.name}`,
        responseType: "blob", // important
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", item.name);
        document.body.appendChild(link);
        link.click();
      });
    },
    createBackup(item) {
      this.btn_loading = true;
      this.axios
        .post("backups")
        .then((res) => {
          this.btn_loading = false;
          this.$store.commit("showSnackbar", {
            text: this.$t("save_succeed"),
            stateType: "success",
            show: true,
          });
          this.getData();
        })
        .catch((err) => {
          this.btn_loading = false;
        });
    },
  },
  created() {
    this.getData();
  },
};
</script>
<style>
.lable-out _less {
  right: -16px;
  position: relative;
  min-width: 100px;
  text-align: center;
}
.draggable {
  cursor: move; /* fallback if grab cursor is unsupported */
  cursor: grab;
  cursor: -moz-grab;
  cursor: -webkit-grab;
}

/* (Optional) Apply a "closed-hand" cursor during drag operation. */
.draggable:active {
  cursor: grabbing;
  cursor: -moz-grabbing;
  cursor: -webkit-grabbing;
}
</style>
